// extracted by mini-css-extract-plugin
module.exports = {"detailTitle":"project-beneficiaries_detailTitle__3CgzV","SuperposicionTitle":"project-beneficiaries_SuperposicionTitle__1KufV"};